module.exports = __webpack_public_path__ + "media/tta-vid2.adc66ee1.mp4";